import React from "react";

export const defaultWorkforceGenderRows = [
  { category: "Executive Management", female: "", male: "", notDisclosed: "" },
  {
    category: "Non-Executive Management",
    female: "",
    male: "",
    notDisclosed: "",
  },
  { category: "Technical Employees", female: "", male: "", notDisclosed: "" },
  { category: "All Other Employees", female: "", male: "", notDisclosed: "" },
];

const WorkforceGenderTable = ({
  workforceGenderTable,
  setWorkforceGenderTable,
}) => {
  // Same idea as the turnover table's safeTableData
  const safeTableData =
    Array.isArray(workforceGenderTable) && workforceGenderTable.length
      ? workforceGenderTable
      : defaultWorkforceGenderRows;

  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...safeTableData]; // clone current rows (saved or defaults)
    updated[rowIndex][field] = value;
    setWorkforceGenderTable(updated); // push up to parent/Redux
  };

  return (
    <div
      style={{
        marginTop: "16px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "100%",
        maxWidth: "none",
        marginInline: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "16px",
              }}
            >
              Category
            </th>
            <th style={tableHeaderStyle}>Female (%)</th>
            <th style={tableHeaderStyle}>Male (%)</th>
            <th style={tableHeaderStyle}>Not disclosed (%)</th>
          </tr>
        </thead>

        <tbody>
          {safeTableData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "600",
                  paddingLeft: "16px",
                  backgroundColor: "#D3C9CE",
                  whiteSpace: "normal",
                }}
              >
                {row.category}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.female}
                  onChange={(e) =>
                    handleInputChange(index, "female", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.male}
                  onChange={(e) =>
                    handleInputChange(index, "male", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.notDisclosed}
                  onChange={(e) =>
                    handleInputChange(index, "notDisclosed", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "20px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.2,
};

const tableCellStyle = {
  padding: "13px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.2,
};

const inputStyle = {
  width: "80%",
  padding: "10px",
  height: "34px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default WorkforceGenderTable;
